function encodeQueryParams(attributes) {
  try {
    const params = Object.keys(attributes)
      .filter((key) => attributes[key] === false || attributes[key])
      .map((key) => `${key}=${attributes[key]}`);
    return `?${params.join('&')}`;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error encoding query parameters', error);
    return '';
  }
}

export default encodeQueryParams;
